import { Popover } from 'components/ui';

import { JsonTrigger, PopoverContent } from './JsonField.style';
import { parseJsonObjectString, renderDenseJson } from './jsonField.utils';

type Props = {
  keyValue: string;
  value: string;
};

export const JsonFieldValue = ({ keyValue, value }: Props) => {
  const parsed = parseJsonObjectString(value);

  if (!parsed) {
    return <div key={keyValue}>{value}</div>;
  }

  return (
    <Popover
      trigger={['hover', 'focus']}
      placement="rightTop"
      content={<PopoverContent>{renderDenseJson(parsed)}</PopoverContent>}
    >
      <JsonTrigger type="button">JSON</JsonTrigger>
    </Popover>
  );
};
